const initAddStyleToIframes = () => {
    // Function to apply styles to the iframe
    function styleIframe(iframeSelector) {
        // Get the iframe element
        const iframe = document.querySelector(iframeSelector);

        // Check if the iframe exists and is loaded
        iframe.onload = function () {
            const iframeDoc = iframe.contentDocument || iframe.contentWindow.document;

            // Add a <style> tag to the iframe
            const style = iframeDoc.createElement('style');
            style.type = 'text/css';

            // Add @import for the Google Font
            style.innerHTML = `
            @import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&display=swap');
            body {
                font-family: 'Roboto', sans-serif !important;
            }
        `;

            // Append the style to the iframe's <head> or <body>
            const head = iframeDoc.head || iframeDoc.getElementsByTagName('head')[0];
            if (head) {
                head.appendChild(style);
            } else {
                iframeDoc.body.insertBefore(style, iframeDoc.body.firstChild);
            }
        };
    }

    if (document.querySelector('.woocommerce-order-pay .payment_box iframe')) {
        styleIframe('.woocommerce-order-pay .payment_box iframe');
    }
}

export {initAddStyleToIframes}
